export default {
  discountDeposit: {
    backgroundColor: "#d8d8d8",
    padding: 8,
    marginTop: 0,
    marginBottom: 5
  },
  discountPercent: {
    paddingLeft: 10,
  },
  financeCell: {
    flexGrow: 1,
    borderWidth: 1,
    borderColor: "#d8d8d8",
    borderStyle: "solid",
    borderRadius: 5,
    padding: 5,
  },
  financeCellMonths: {
    fontSize: 11,
  },
  financeCellText: {
    fontSize: 15,
  }
}
